import { onBeforeUnmount, onMounted, readonly, ref } from '@nuxtjs/composition-api';

export const CONSENT_STUDIO_COOKIE_KEY = 'consent-studio__storage';
export const CONSENT_STUDIO_UPDATED_EVENT = 'consent-studio__updated';

export const hasMarketingConsentGranted = () => {
  if (!process.client) return false;

  try {
    const accepted = window.consentStudio?.api?.consentState?.hasMarketing?.();

    if (typeof accepted === 'boolean') {
      return accepted;
    }
  } catch (error) {
    // Fall back to the consent cookie while Consent Studio is still booting.
  }

  const consentCookie = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(`${CONSENT_STUDIO_COOKIE_KEY}=`));

  if (!consentCookie) return false;

  const cookieValue = consentCookie.split('=').slice(1).join('=');

  try {
    return decodeURIComponent(cookieValue).includes('marketing');
  } catch (error) {
    return cookieValue.includes('marketing');
  }
};

export default function useMarketingConsent() {
  const hasMarketingConsent = ref(false);

  const syncMarketingConsent = () => {
    hasMarketingConsent.value = hasMarketingConsentGranted();
  };

  onMounted(() => {
    syncMarketingConsent();
    window.addEventListener(CONSENT_STUDIO_UPDATED_EVENT, syncMarketingConsent);
  });

  onBeforeUnmount(() => {
    window.removeEventListener(CONSENT_STUDIO_UPDATED_EVENT, syncMarketingConsent);
  });

  return {
    hasMarketingConsent: readonly(hasMarketingConsent)
  };
}
